//Todo :
// This was added as part of vertica changes to preserve the adapter name.
// The plan is to remove database suffix from the adapters, if not required.
// Or to check on why database is being replaced and take necessary action

const PRESERVED_TARGET_NAMES = ["Database", "OpenText Analytics Database (Vertica)", "Fabric Mirrored database"];

export const replaceDatabaseInTarget = adapterName => {
    if (!adapterName) {
        return null;
    }
    adapterName = adapterName.trim();
    const toPreserveAdapterName = PRESERVED_TARGET_NAMES.includes(adapterName);
    if (!toPreserveAdapterName) {
        adapterName = adapterName.replace("Database", "").trim();
    }
    return adapterName;
};
